import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  deleteSeasonRateRuleAsync,
  getSeasonRatePriceChangeRuleAsync,
  selectPriceChangeRuleDetails,
  selectPriceChangeRuleDetailsLoadingStatus,
  updateSeasonRatePriceChangeRuleAsync,
} from '../seasonRateRulesSlice';
import { PriceChangeRuleDetails } from '../../../common/types/rates.types';
import PriceChangeForm from './PriceChangeForm';
import { getSeasonRatesAsync } from '../../seasonRates/seasonRatesSlice';

function SeasonRatePriceChange({
  seasonRateId,
  accommodationId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  accommodationId?: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const priceChangeRuleDetails = useAppSelector(selectPriceChangeRuleDetails);
  const priceChangeStatus = useAppSelector(
    selectPriceChangeRuleDetailsLoadingStatus,
  );

  const initialData: PriceChangeRuleDetails = {
    seasonRateId,
    priceChange: {
      priceChangeType: 0,
      percent: 0,
      difference: 0,
    },
    isActive: true,
    isCopyable: true,
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    dispatch(getSeasonRatePriceChangeRuleAsync(seasonRateId));
  }, [seasonRateId, dispatch]);

  useEffect(() => {
    if (priceChangeRuleDetails && priceChangeRuleDetails.id) {
      setData(priceChangeRuleDetails);
    } else {
      setData(initialData);
    }
  }, [priceChangeRuleDetails]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setData(newData);
  };

  const handleSelectChange = (selectedOption, name) => {
    const path = name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] = selectedOption.value;
    setData(newData);
  };

  const onSubmit = async () => {
    const actionResult = await dispatch(
      updateSeasonRatePriceChangeRuleAsync(data),
    );
    if (updateSeasonRatePriceChangeRuleAsync.fulfilled.match(actionResult)) {
      setSubmitted(true);
      if (accommodationId) {
        dispatch(getSeasonRatesAsync({ accommodationId }));
      }
    }
  };

  const onDelete = async () => {
    if (window.confirm('Haluatko varmasti poistaa säännön?')) {
      const actionResult = await dispatch(deleteSeasonRateRuleAsync(data.id));
      if (deleteSeasonRateRuleAsync.fulfilled.match(actionResult)) {
        setSubmitted(false);
        setData(initialData);
        setDeleted(true);

        dispatch(getSeasonRatesAsync({ accommodationId }));
      }
    }
  };

  return (
    <PriceChangeForm
      loadingStatus={priceChangeStatus}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitted={submitted}
      deleted={deleted}
      data={data}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRatePriceChange;
